//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class BenefitWithIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { icon, text, className } = this.props;
    const componentClasses = classNames(styles.BenefitWithIcon, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        {icon}
        <h2 className={styles.Text}>{text}</h2>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(BenefitWithIcon);
